import styled from 'styled-components'
import { MaxWidthGridV2 } from 'Layout'

// import { Link } from 'react-scroll'
import AppLink from 'Components/AppLink'
import {
  TERTIARY_COLOR, CLICKABLE_COLOR,
  THEME_DANGER_COLOR,
} from '@CSSVars/colors'
// import { BREAK_POINT_SM, BREAK_POINT_MD, BREAK_POINT_LG } from '@CSSVars/variables'


export const _CompareGrid = styled.div`
  width: 100%;
  position: fixed;
  bottom: 0;
  transition: bottom 0.25s 0.15s ease-in-out;
  z-index: 2003;
`

export const _Background = styled.div`
  ${({ isOpen }) => (isOpen ? `
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, .5);
    transition: background-color 0.3s ease-in-out;
    display: flex;
    align-items: flex-end;
  ` : '')}
`


export const _ClickableLip = styled.div`
  height: 24px;
  width: 100%;
  background-color: ${TERTIARY_COLOR};
  cursor: pointer;
  pointer-events: initial;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    fill: white;
    margin-left: 10px;
    transform: rotate(${({ isOpen }) => (isOpen ? '0' : '180deg')});
    transition: transform .3s;
  }
`

export const _GridBody = styled.div`
  width: 100%;
  background-color: white;
  transition: height 0.25s 0.15s ease-in-out;

`

export const _GridBodyInner = styled(MaxWidthGridV2)`
  padding: 24px 0;
`

export const _MsgAndCta = styled.div`
  margin-bottom: 6px;
  width: 100%;
  display: flex;

  align-items: center;
  justify-content: space-between;
`

export const _MainMessage = styled.div`
  text-align: center;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
`

export const _FullMsg = styled.span`
  && {
    font-weight: 500;
    font-size: 16px;
    color: ${THEME_DANGER_COLOR};
  }
`

export const _CtaCol = styled.div`
  width: 270px;
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

export const _ClearBtn = styled.div`
  margin-right: 24px;
  font-size: 14px;
  line-height: 22px;
  cursor: pointer;
`

export const _CompareBtn = styled(AppLink)`
  height: 44px;
  width: 180px;
  background-color: ${CLICKABLE_COLOR};
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
`
